export var ConditionType;
(function (ConditionType) {
    ConditionType[ConditionType["Bit"] = 0] = "Bit";
    ConditionType[ConditionType["Word"] = 1] = "Word";
})(ConditionType || (ConditionType = {}));
